import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

export const isAuthGuard: CanActivateFn = () => {
  const _authenticationService = inject(AuthService);
  const router = inject(Router);

  if (_authenticationService.isAuthenticated$.value) {
    return true;
  }

  router.navigate(['/login/sso']);
  return false;
};
